export const handoffsConstants = {
    errors: {
        fetchFailed: "Failed to load handoffs.",
        criteriaListFailed: "Failed to load handoff criteria.",
        criteriaCreateFailed: "Failed to create criteria.",
        criteriaUpdateFailed: "Failed to update criteria.",
        criteriaDeleteFailed: "Failed to delete criteria.",
        toggleFailed: "Failed to toggle criteria.",
        genericError: "Something went wrong.",
    },
    messages: {
        criteriaCreated: "Criteria added.",
        criteriaUpdated: "Criteria updated.",
        criteriaDeleted: "Criteria deleted.",
    },
};
